import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Box, Button, Menu, Paper } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import CreateNewFileButton from "../CreateNewFileButton";
import CreateNewFolderButton from "../CreateNewFolderButton";
import CreateNewProtectedFileButton from "../CreateNewProtectedFileButton";
var CreateNewButton = function (_a) {
    var _b = _a.hideCreateProtected, hideCreateProtected = _b === void 0 ? false : _b, _c = _a.hideFolderOptions, hideFolderOptions = _c === void 0 ? false : _c;
    var theme = useTheme();
    var _d = useState(null), optionsEl = _d[0], setOptionsEl = _d[1];
    var handleClick = function () {
        setOptionsEl(null);
    };
    return (_jsxs(Box, { sx: { marginLeft: "auto" }, children: [_jsx(Button, { startIcon: _jsx(AddIcon, { fontSize: "small" }), variant: "contained", color: "secondary", onClick: function (event) { return setOptionsEl(event.currentTarget); }, "data-testid": "New-Item-Btn", children: "New" }), _jsx(Menu, { open: !!optionsEl, anchorEl: optionsEl, onClose: function () { return setOptionsEl(null); }, sx: {
                    width: "300px",
                }, PaperProps: {
                    sx: {
                        width: "300px",
                    },
                }, children: _jsxs(Paper, { tabIndex: -1, onKeyDown: function (event) {
                        if (event.key === "Tab") {
                            event.stopPropagation();
                        }
                    }, elevation: 0, children: [_jsx(CreateNewFolderButton, { ButtonProps: {
                                sx: {
                                    color: theme.palette.text.primary,
                                    width: "100%",
                                    paddingLeft: 2,
                                    justifyContent: "start",
                                },
                                // @ts-ignore
                                "data-testid": "New-Folder-Btn",
                            }, onClose: handleClick, hideFolderOptions: hideFolderOptions }), _jsx(CreateNewFileButton, { ButtonProps: {
                                sx: {
                                    color: theme.palette.text.primary,
                                    width: "100%",
                                    paddingLeft: 2,
                                    justifyContent: "start",
                                },
                                // @ts-ignore
                                "data-testid": "New-File-Btn",
                            }, onClose: handleClick }), !hideCreateProtected && (_jsx(CreateNewProtectedFileButton, { ButtonProps: {
                                sx: {
                                    color: theme.palette.text.primary,
                                    width: "100%",
                                    paddingLeft: 2,
                                    justifyContent: "start",
                                },
                                // @ts-ignore
                                "data-testid": "New-ProtectedFile-Btn",
                            }, onClose: handleClick }))] }) })] }));
};
export default CreateNewButton;
